let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kap3Y")).then(() => parcelRequire('7TH4E'));